<template>
    <div class="home">

        <logo modifier="logo--home"></logo>

        <div class="main-page-content__title">
            <h1>Kérdőív</h1>
        </div>
        <div class="main-page-content__text">
            <p>Ha felkészült kattintson a nyílra</p>
        </div>

        <button-next v-bind:link="{ name: 'quizScreen'}">
        </button-next>

    </div>
</template>

<script>
    import Vue from 'vue';
    import ButtonNext from '@/components/shared/ButtonNext';
    import Logo from '@/components/shared/LogoElement';

    export default {
        name: 'Home',

        components: {
            'button-next': ButtonNext,
            'logo': Logo,
        },

        data: function () {
            return {
                shuffledQuestions: []
            };
        },

        methods: {
            init: function(){

                this.shuffleQuestions();
                this.addAnswered();
                this.saveQuestions();
            },

            resetData: function(){
                localStorage.removeItem(Vue.localStorageName);
            },

            saveQuestions: function () {
                const parsed = JSON.stringify(this.shuffledQuestions);
                localStorage.setItem(Vue.localStorageName, parsed);
            },

            shuffleQuestions: function () {

                var questionArray = [...Vue.quizData]; //copy array

                for (var i = 0; i < Vue.questionMaxCount; i++) {
                    var rnd = this.getRandomInt(questionArray.length);

                    this.shuffledQuestions.push(questionArray[rnd]);

                    questionArray.splice(rnd, 1);
                }
            },

            getRandomInt: function (max) {
                return Math.floor(Math.random() * Math.floor(max));
            },

            addAnswered: function () {
                this.shuffledQuestions.forEach(element => {
                    element.answered = "";
                });
            }
        },

        mounted() {
            this.resetData();
            this.init();
        }
    }
</script>

<style lang="scss">
    .home {
        height: 100vh;
        width: 100%;
        background: url('~@/assets/images/background-gray.png');
        text-align: center;
    }

    .main-page-content {

        &__title {

            h1, h2 {
                font-weight: 500;
                font-size: 36px;
                text-transform: uppercase;
                line-height: 86px;
                letter-spacing: 7px;
                margin: 0px;
            }
        }

        &__text {

            p {
                font-size: 18px;
                line-height: 59px;
                text-transform: uppercase;
                margin: 0px 0px 18px 0px;
            }
        }
    }
</style>
